
<div class="transcript-container">
  <div class="transcript-actions">
    <button mat-icon-button (click)="downloadTranscript()" matTooltip="{{ 'TRANSCRIPT.DOWNLOAD' | translate }}">
      <mat-icon>save_alt</mat-icon>
    </button>
    <button mat-icon-button (click)="copyAllTranscript()" matTooltip="{{ 'TRANSCRIPT.COPY_TRANSCRIPT' | translate }}">
      <mat-icon>content_copy</mat-icon>
    </button>
  </div>
  <glxy-transcript [transcript]="transcript()" (contentClicked)="clickedContent($event)"></glxy-transcript>
</div>
<a #downloadAnchor [hidden]="true"></a>
